export default {
    'name': 'desktop',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M20 16.5C20 16.7761 19.7761 17 19.5 17H12H4.5C4.22386 17 4 16.7761 4 16.5V15.25H20V16.5ZM13 19H19.5C20.8807 19 22 17.8807 22 16.5V14.25V6C22 4.61929 20.8807 3.5 19.5 3.5H4.5C3.11929 3.5 2 4.61929 2 6V14.25V16.5C2 17.8807 3.11929 19 4.5 19H11V20H9C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22H12H15C15.5523 22 16 21.5523 16 21C16 20.4477 15.5523 20 15 20H13V19ZM4 6V13.25H20V6C20 5.72386 19.7761 5.5 19.5 5.5H4.5C4.22386 5.5 4 5.72386 4 6Z\' fill=\'#006CFD\'/>'
}
